import { getAutordata, filialabholungAngezeigt } from "./src/dl-pageview.js";

class ArtikeldetailseiteGlobal extends HTMLElement {
    connectedCallback() {
        this.initTracking();
        this.initVISHotjar();
    }

    initTracking() {
            const pageview = this.querySelector("dl-pageview");
            pageview.setAttribute("produktautor", getAutordata(this.autoren, "name"));
            pageview.setAttribute("autorid", getAutordata(this.autoren, "id"));
            pageview.setAttribute("anzeigefilialabholungswidget", filialabholungAngezeigt());
    }

    initVISHotjar() {
        if (window.hj) hj('trigger', 'ADS_VIS');
    }

    get autoren() {
        const autoren = this.dataset["autoren"];
        return JSON.parse(autoren);
    }
}

if (!customElements.get("artikeldetailseite-global")) {
    customElements.define("artikeldetailseite-global", ArtikeldetailseiteGlobal);
}
